import React from 'react';
import CalendarPickupStack from './CalendarPickupStack';
import { useDroppable } from '@dnd-kit/core';

const CalendarSlot = ({
  day,
  hour,
  children,
  isToday,
  pickups = [],
  expanded,
  onToggle,
}) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `slot-${day.format('YYYY-MM-DD')}-${hour}`,

    data: {
      day,
      hour,
    },
  });

  return (
    <div
      ref={setNodeRef}
      style={{
        height: '120px',
        borderBottom: '1px solid #f3f4f6',
        position: 'relative',

        backgroundColor: isOver ? '#add0ff' : isToday ? '#ddebff' : '#fff',

        transition: '0.2s ease',
      }}
    >
      {children}
      {pickups.length > 0 && (
        <CalendarPickupStack
          pickups={pickups}
          expanded={expanded}
          onToggle={onToggle}
        />
      )}
    </div>
  );
};

export default CalendarSlot;
